import React, { useMemo, useRef, useState } from "react"
import PropTypes from "prop-types"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import { BLOCKS } from "@contentful/rich-text-types"
import ArrowDropUpFilled from "../../../../../static/images/ArrowDropUpFilled.svg"
import ArrowDropDownFilled from "../../../../../static/images/ArrowDropDownFilled.svg"
import "./card.scss"

const options = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (node, children) => {
      const isEmpty =
        !children ||
        (Array.isArray(children) &&
          children.every(
            child => typeof child === "string" && child.trim().length === 0
          ))
      return isEmpty ? null : <p>{children}</p>
    },
  },
}

const Card = ({ backgroundColor, layoutStyle, media, text, title }) => {
  const [expanded, setExpanded] = useState(false)

  const contentIdRef = useRef(
    `info-card-${Math.random().toString(36).slice(2, 11)}`
  )
  const contentId = contentIdRef.current

  const imageUrl = media?.image?.file?.url
  const alt = media?.image?.alt || media?.image?.title

  const isGrid = layoutStyle === "grid"
  const showToggle = isGrid

  const renderedTitle = useMemo(() => {
    return title?.text?.json
      ? documentToReactComponents(title.text.json, options)
      : null
  }, [title?.text?.json])

  const renderedText = useMemo(() => {
    return text?.json ? documentToReactComponents(text.json, options) : null
  }, [text?.json])

  return (
    <div
      className={`info-card info-card--${layoutStyle} ${
        backgroundColor ? `--${backgroundColor}` : ""
      } ${showToggle ? "info-card--grid-toggle" : ""}`}
    >
      {imageUrl && (
        <img alt={alt} className="info-card__image" src={imageUrl} />
      )}

      <div className="info-card__content">
        <div className="info-card__title-row">
          <div className="info-card__title">{renderedTitle}</div>

          {showToggle && (
            <button
              aria-controls={contentId}
              aria-expanded={expanded}
              aria-label={expanded ? "Collapse" : "Expand"}
              className="info-card__toggle-btn"
              onClick={() => setExpanded(prev => !prev)}
              type="button"
            >
              <img
                alt=""
                aria-hidden="true"
                className={expanded ? "open" : ""}
                src={expanded ? ArrowDropUpFilled : ArrowDropDownFilled}
              />
            </button>
          )}
        </div>

        <div
          className={`info-card__text ${
            isGrid && !expanded ? "collapsed" : ""
          }`}
          id={contentId}
        >
          {renderedText}
        </div>
      </div>
    </div>
  )
}

Card.propTypes = {
  backgroundColor: PropTypes.string,
  layoutStyle: PropTypes.oneOf(["grid", "stacked"]),
  media: PropTypes.shape({
    image: PropTypes.shape({
      file: PropTypes.shape({
        url: PropTypes.string,
      }),
      alt: PropTypes.string,
      title: PropTypes.string,
    }),
  }),
  text: PropTypes.shape({
    json: PropTypes.object,
  }),
  title: PropTypes.shape({
    text: PropTypes.shape({
      json: PropTypes.object,
    }),
  }),
}

export default Card
